module.exports = __webpack_public_path__ + "media/heart-bubble-eaae2893.svg";